import React from 'react';

const VerticalStrip = ({
  width = '4',
  height = '16',
  className,
  fill,
  ...rest
}) => {
  return (
    <svg
      width="4"
      height="16"
      viewBox="0 0 4 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...rest}
    >
      <rect width="4" height="16" rx="1" fill={fill} />
    </svg>
  );
};

export default VerticalStrip;
